export enum EnvironmentName {
  None = 0,
  Internal = 1,
  TestSlice = 2,
  FirstSlice = 3,
}
